import { ModalTrigger as ReactModalTrigger } from "@certn/cascadia-react/components/modal/ModalTrigger";
import { memo } from "react";

import { CascadiaModalTriggerProps } from "./types";

export const ModalTrigger = memo(function (props: CascadiaModalTriggerProps) {
  return <ReactModalTrigger {...props} />;
});
